import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

export interface Therapy {
  name: string;
  link: string;
  image: () => React.ReactNode;
}

export const useServiceTherapies = (): Therapy[] => {
  const data = useStaticQuery(graphql`
     query {
        allMdx(sort: {frontmatter: {order: ASC}})  {
        nodes {
          frontmatter {
            title
            slug
            image {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  placeholder: BLURRED
                  quality: 85
                  width: 800
                )
              }
            }
          }
        }
      }
    }
  `);

  return data.allMdx.nodes
    .filter((node: any) => node.frontmatter.slug && node.frontmatter.title)
    .map((node: any) => ({
      name: node.frontmatter.title,
      link: `/services/${node.frontmatter.slug}`,
      image: () => {
        const img = getImage(node.frontmatter.image?.childImageSharp);
        return img ? (
          <GatsbyImage
            image={img}
            alt={node.frontmatter.title}
            className="w-full h-auto rounded-lg"
          />
        ) : null;
      },
    }));
};
